'use strict';
let subscribers = {};

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target?.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);
  var formatType = match ? match[1] : 'amount';

  switch (formatType) {
    case 'amount':
      value = formatWithDelimiters(cents, 2); // 1,234.56
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0); // 1234
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ','); // 1.234,56
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ','); // 1.234
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ','); // 1 234,56
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', ','); // 1 234
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.'); // 1'234.56
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'", '.'); // 1'234
      break;
    default:
      value = formatWithDelimiters(cents, 2); // 1234.56
      break;
  }

  var formattedMoney = match
    ? formatString.replace(placeholderRegex, value)
    : value + ' ' + formatString.trim();
  var currencyIsoCode = window.cartStrings?.currency_iso_code;

  if (
    currencyIsoCode === 'MYR' &&
    formattedMoney.includes('RM') &&
    formattedMoney.includes('MYR')
  ) {
    formattedMoney = formattedMoney
      .replace(/ MYR/g, '')
      .replace(/MYR /g, '')
      .replace(/MYR/g, '');
  }

  return formattedMoney;
};
var getScrollBarWidth = (function () {
  var _cached = null;
  return {
    init: function () {
      if (_cached !== null) return _cached;
      var scrollDiv = document.createElement('div');
      scrollDiv.style.width = '100px';
      scrollDiv.style.height = '100px';
      scrollDiv.style.overflow = 'scroll';
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      document.body.appendChild(scrollDiv);
      _cached = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return _cached;
    },
    reset: function () { _cached = null; }, // call on viewport resize if needed
  };
})();
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      if (data) {
        callback(data);
      } else {
        callback();
      }
    });
  }
}

var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest('motion-element')
                      ?.classList.remove('bls-loading-image');
                    target?.classList.remove('bls-loading-image');
                  }, 600);
                  e.currentTarget.removeEventListener('load', onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                // Don't override sizes for high priority images (fetchpriority="high")
                // as they are already preloaded with correct sizes
                if (entry.target.getAttribute('fetchpriority') !== 'high') {
                  entry.target.sizes = `${entry.boundingClientRect.width}px`;
                }
                entry.target.addEventListener('load', onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '10px' }
        );
        document.querySelectorAll('.bls-image-js img').forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
function CloseAllPopup(data) {
  publish('closeCanvas', data);
}

let parser = new DOMParser();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
};
const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === 'IMG' && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest('motion-element')
              ?.classList.remove('bls-loading-image');
            image.classList.remove('bls-loading-image');
            resolve();
          }, 100);
        } else {
          image.addEventListener('load', (e) => {
            e.currentTarget
              .closest('motion-element')
              ?.classList.remove('bls-loading-image');
            e.currentTarget.classList.remove('bls-loading-image');
            resolve();
          });
        }
      });
    })
  );
};
class MotionElement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.isHold) return;
    this.preInitialize();
    if (this.dataset.noview) {
      return;
    }
    if (!this.isConnected || !document.body.contains(this)) {
      setTimeout(() => {
        this.connectedCallback();
      }, 100);
      return;
    }

    var _this = this;
    let custom_margin = this.dataset.margin || '0px 0px -5px 0px';
    let rootElement = {};
    if (this.dataset.parent) {
      var parent = this.closest(`.${this.dataset.parent}`);
      rootElement = { root: parent };
      custom_margin = '0px 0px 0px 0px';
    }
    motion.inView(
      _this,
      async () => {
        if (
          !this.isInstant &&
          this.mediaElements &&
          this.hasAttribute('data-image')
        ) {
          await imageReady(this.mediaElements);
        }
        setTimeout(() => {
          _this.initialize();
        }, 50);
      },
      { margin: custom_margin, ...rootElement }
    );
  }

  get isHold() {
    return this.hasAttribute('hold');
  }

  get Transition() {
    let transition = this.getAttribute('data-transition')
      ?.split(',')
      .map(Number);
    return transition || [0, 0, 0.3, 1];
  }

  get isInstant() {
    return this.hasAttribute('data-instantly');
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll('img, iframe, svg'));
  }

  get animationType() {
    return this.dataset.motion || 'fade-up';
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000;
  }

  set animationDelay(value) {
    this.dataset.motionDelay = value;
  }

  preInitialize() {
    if (this.isHold) return;
    switch (this.animationType) {
      case 'fade-in':
        motion.animate(this, { opacity: 0.01 }, { duration: 0 });
        break;

      case 'fade-up':
        motion.animate(
          this,
          { transform: 'translateY(2.5rem)', opacity: 0.01 },
          { duration: 0 }
        );
        break;

      case 'fade-up-sm':
        motion.animate(
          this,
          { transform: 'translateY(1rem)', opacity: 0.01 },
          { duration: 0 }
        );
        break;

      case 'fade-up-lg':
        motion.animate(
          this,
          { transform: 'translateY(4rem)', opacity: 0.01 },
          { duration: 0 }
        );
        break;

      case 'zoom-in':
        motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 });
        break;
      case 'zoom-in-lg':
        motion.animate(this, { transform: 'scale(0)' }, { duration: 0 });
        break;

      case 'zoom-out':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 });
        break;

      case 'zoom-out-sm':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 });
        break;
      case 'zoom-out-lg':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 });
        break;
    }
  }

  async initialize() {
    if (this.isHold) return;
    switch (this.animationType) {
      case 'fade-in':
        await motion.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: this.animationDelay, easing: this.Transition }
        ).finished;
        break;

      case 'fade-up':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.Transition,
          }
        ).finished;
        break;

      case 'fade-up-sm':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.3,
            delay: this.animationDelay,
            easing: this.Transition,
          }
        ).finished;
        break;

      case 'fade-up-lg':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.Transition,
          }
        ).finished;
        break;

      case 'zoom-in':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.3, delay: this.animationDelay, easing: this.Transition }
        ).finished;
        break;

      case 'zoom-in-lg':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 0.5, delay: this.animationDelay, easing: this.Transition }
        ).finished;
        break;

      case 'zoom-out':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.5, delay: this.animationDelay, easing: this.Transition }
        ).finished;
        break;

      case 'zoom-out-sm':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: this.Transition }
        ).finished;
        break;
      case 'zoom-out-lg':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: this.Transition }
        ).finished;
        break;
    }
  }
  refreshAnimation() {
    this.removeAttribute('hold');
    this.preInitialize();
    setTimeout(() => {
      this.initialize();
    }, 50); // Delay a bit to make animation re init properly.
  }
}
customElements.define('motion-element', MotionElement);

// Track loaded stylesheets to prevent duplicate loading
const loadedStylesheets = new Set();
// Cache DOM query results to avoid repeated queries
const domQueryCache = new Map();

// Get asset base URL from existing script tags (cached for performance)
let cachedAssetBaseUrl = null;
function getAssetBaseUrl() {
  if (cachedAssetBaseUrl !== null) {
    return cachedAssetBaseUrl;
  }
  const existingScript = document.querySelector('script[src*="global.js"]');
  if (existingScript && existingScript.src) {
    const match = existingScript.src.match(/^(.*\/)assets\//);
    if (match) {
      cachedAssetBaseUrl = match[1] + 'assets/';
      return cachedAssetBaseUrl;
    }
  }
  cachedAssetBaseUrl = '/assets/';
  return cachedAssetBaseUrl;
}

// Load stylesheet dynamically (non-blocking, async)
function loadStylesheet(href) {
  // Normalize href for comparison (extract filename)
  const hrefKey = href.split('/').pop();
  
  if (loadedStylesheets.has(hrefKey)) {
    return;
  }

  // Check cache first to avoid DOM query
  if (domQueryCache.has(hrefKey)) {
    const cachedResult = domQueryCache.get(hrefKey);
    if (cachedResult) {
      loadedStylesheets.add(hrefKey);
      return;
    }
    // If cached as false, continue to load
  } else {
    // Query DOM only once and cache the result
    const existingLink = document.querySelector(`link[href*="${hrefKey}"]`);
    if (existingLink) {
      domQueryCache.set(hrefKey, true);
      loadedStylesheets.add(hrefKey);
      return;
    }
    // Cache negative result to avoid repeated queries
    domQueryCache.set(hrefKey, false);
  }

  // Use requestIdleCallback for non-blocking load, fallback to setTimeout
  const loadStylesheetAsync = () => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    // Use media="print" trick to load asynchronously, then switch to "all"
    link.media = 'print';
    link.onload = function() {
      this.media = 'all';
      loadedStylesheets.add(hrefKey);
    };
    link.onerror = () => {
      console.warn(`Failed to load stylesheet: ${href}`);
    };
    document.head.appendChild(link);
  };

  // Load in next idle period or after a short delay
  if (typeof window.requestIdleCallback !== 'undefined') {
    requestIdleCallback(loadStylesheetAsync, { timeout: 2000 });
  } else {
    // Fallback: use setTimeout with minimal delay
    setTimeout(loadStylesheetAsync, 0);
  }
}

class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (this.dataset.swipeMobileOnly === 'true') {
      this._initSwipeMobileOnly();
    } else if (document.body.classList.contains('index')) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains('swiper-lazy')) {
        this.initSlide();
      } else {
        if (this.classList.contains('lazy-loading-swiper-before')) {
          this.initSlide();
        } else {
          this.classList.add('lazy-loading-swiper-after');
        }
      }
    } else {
      this.initSlide();
    }
  }

  /**
   * Swiper only under 768px (e.g. desktop uses CSS grid). Avoids init while display:none on wide viewports.
   */
  _destroySwiperInstance() {
    if (this._resizeTiktok) {
      window.removeEventListener('resize', this._resizeTiktok);
      this._resizeTiktok = null;
    }
    if (this._resizeMatchHeight) {
      window.removeEventListener('resize', this._resizeMatchHeight);
      this._resizeMatchHeight = null;
    }
    if (this.globalSlide && typeof this.globalSlide.destroy === 'function' && !this.globalSlide.destroyed) {
      this.globalSlide.destroy(true, true);
    }
    this.globalSlide = null;
    this.classList.remove('swiper-initialized');
  }

  _initSwipeMobileOnly() {
    const mq = window.matchMedia('(max-width: 767.98px)');
    this._mobileOnlyMq = mq;
    const runSync = () => {
      if (mq.matches) {
        if (!this.globalSlide || this.globalSlide.destroyed) {
          this.initSlide();
        }
      } else {
        this._destroySwiperInstance();
      }
    };
    this._mobileOnlySync = runSync;
    runSync();
    mq.addEventListener('change', this._mobileOnlySync);
  }

  initSlide() {
    // Use requestIdleCallback to avoid blocking main thread
    const _this = this;
    const initSlideInternal = () => {
      var autoplaying = _this?.dataset.autoplay === 'true';
      const loop = _this?.dataset.loop === 'true';
      const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
      var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : '';
      const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
      const direction = _this?.dataset.direction
        ? _this?.dataset.direction
        : 'horizontal';
      var autoplaySpeed = _this?.dataset.autoplaySpeed
        ? _this?.dataset.autoplaySpeed * 1000
        : 3000;
      _this.style.setProperty('--autoplaying', autoplaying ? 0 : 1);
      _this.style.setProperty('--autorotate_speed', `${autoplaySpeed}ms`);
      var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
      const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide';
      const row = _this?.dataset.row ? _this?.dataset.row : 1;
      var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
      const progressbar = _this?.dataset.paginationProgressbar === 'true';
      const paginationType = _this?.dataset.paginationType || (progressbar ? 'progressbar' : 'bullets');
      const autoItem = _this?.dataset.itemMobile === 'true';
      const autoHeight = _this?.dataset.autoHeight === 'true';
      const arrowCenterimage = _this?.dataset.arrowCenterimage
        ? _this?.dataset.arrowCenterimage
        : 0;
    const autoplayPauseOnMouseEnter = _this?.dataset.autoplayPauseOnMouseEnter === 'true';
    const matchHeightSelectors = _this?.dataset.matchHeight ? _this.dataset.matchHeight.split(',').map(s => s.trim()) : [];

    let customBreakpoints = null;
    if (_this?.dataset.customBreakpoints) {
      try {
        customBreakpoints = JSON.parse(_this.dataset.customBreakpoints);
      } catch (e) {
        console.error('Invalid custom breakpoints JSON', e);
      }
    }
    const centeredSlides = _this?.dataset.centeredSlides === 'true';
    const grabCursor = _this?.dataset.grabCursor === 'true';
    const keyboardNav = _this?.dataset.keyboard === 'true';
    const slideToClickedSlide = _this?.dataset.slideToClickedSlide === 'true';
    const hashNav = _this?.dataset.hashNav === 'true';
    const hashNavReplace = _this?.dataset.hashNavReplace === 'true';
      const creativePreset = _this?.dataset.creativePreset || 'slide-over';
      const centerLoop = _this?.dataset.centerLoop === 'true';
      const centerClones = _this?.dataset.centerClones ? parseInt(_this.dataset.centerClones, 10) : 2;
      const cardsRotate = _this?.dataset.cardsRotate ? Number(_this.dataset.cardsRotate) : 2;
      const cardsOffset = _this?.dataset.cardsOffset ? Number(_this.dataset.cardsOffset) : 8;
      const cardsRewind = _this?.dataset.rewind !== 'false';

    /* ── Tayler added 20260324 .... Center-peek loop: pre-clone slides before Swiper init ──────────────
       Swiper 11 virtual loop doesn't support centeredSlides peek during animation.
       Solution: disable Swiper's own loop, manually clone N slides at each end,
       then teleport after transition completes (handled in section JS).           */
    let initialSlide = 0;
    if (centerLoop && centeredSlides) {
      const wrapper = _this.querySelector('.swiper-wrapper');
      if (wrapper) {
        const realSlides = Array.from(wrapper.children);
        const n = realSlides.length;
        const nc = centerClones;
        // Prepend clones of last `nc` real slides (prepend in reverse order so DOM order is preserved)
        for (let i = nc - 1; i >= 0; i--) {
          const clone = realSlides[n - nc + i].cloneNode(true);
          clone.classList.add('cm-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          wrapper.prepend(clone);
        }
        // Append clones of first `nc` real slides
        for (let i = 0; i < nc; i++) {
          const clone = realSlides[i].cloneNode(true);
          clone.classList.add('cm-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          wrapper.append(clone);
        }
        initialSlide = nc; // start at first real slide
      }
    }
    // Load progressbar stylesheet if needed (non-blocking, async)
    if (progressbar) {
      // Defer URL calculation and loading to avoid blocking
      setTimeout(() => {
        const assetBaseUrl = getAssetBaseUrl();
        const stylesheetUrl = assetBaseUrl + 'swiper-progressbar.css';
        loadStylesheet(stylesheetUrl);
      }, 0);
    }
    
      spacing = Number(spacing);
      autoplaySpeed = Number(autoplaySpeed);
      speed = Number(speed);
      if (autoplaying) {
        autoplaying = { delay: autoplaySpeed, disableOnInteraction: false };
      }
    if (autoplayPauseOnMouseEnter && autoplaying) {
      autoplaying.pauseOnMouseEnter = true;
    }
    if (autoplaying && _this?.dataset.stopOnLastSlide === 'true') {
      autoplaying.stopOnLastSlide = true;
    }
    
      if (!itemTablet) {
        if (itemDesktop < 2) {
          itemTablet = 1;
        } else if (itemDesktop < 3) {
          itemTablet = 2;
        } else {
          itemTablet = 3;
        }
      }
      /* ── Cards / Cube effect overrides ─────────────────────────────────────────────────────────
         Cards effect internally sets virtualTranslate:true, meaning it manages all per-slide
         CSS transforms itself based on `slide.progress`. Swiper's loop mode works by translating
         the wrapper (or shifting virtual positions), which cards overrides — causing:
           • arrows/drag appear to do nothing (transforms immediately overridden)
           • initial slide order wrong (loop's virtual offset misaligns progress values)
           • nav index out of sync (realIndex unreliable when loop conflicts with virtualTranslate)
         Fix: disable loop and force slidesPerView:1 for cards so wrapper translate is used
         normally and progress values map cleanly to DOM positions.                              */
      const isCardsEffect = effect === 'cards';
      const isCubeEffect  = effect === 'cube';

      /* Vertical sliders must have a fixed height on the swiper container so the
         wrapper (flex-direction:column, total height = all slides stacked) is clipped
         to exactly one slide. Without this, all slides are visible and translateY /
         cube rotations have nothing to scroll within.
         Read the FIRST SLIDE's offsetHeight (not the container's, which = sum of all
         slides) so the constraint matches one slide regardless of slide count.        */
      if (direction == 'vertical') {
        const firstSlide = _this.querySelector('.swiper-slide');
        const slideH = firstSlide ? firstSlide.offsetHeight : 0;
        if (slideH > 0) {
          _this.style.height = slideH + 'px';
          _this.style.overflow = 'hidden';
        }
      }
      const effectiveLoop = isCardsEffect ? false : loop;
      const effectiveSlidesPerView = isCardsEffect ? 1 : (autoItem ? 'auto' : itemMobile);
      const effectiveDirection = isCardsEffect ? 'horizontal' : direction;
      /* cube effect requires spaceBetween:0 — any non-zero value misaligns the 3D
         rotational positions of adjacent slides, breaking next/prev navigation.   */
      const effectiveSpaceBetween = isCubeEffect ? 0 : (spacing >= 15 ? 15 : spacing);

      /* ── Tayler added 20260324 .... Effect-specific config objects ───────────────────────────────
         Only the matching key is consumed by Swiper; others are ignored.
         Shadows are disabled globally — they look poor on full-bleed images. */
      const _creativePresets = {
        'slide-over': { prev: { translate: [0, 0, -400], opacity: 0 },       next: { translate: ['100%', 0, 0] } },
        'zoom-fade':  { prev: { scale: 0.85, opacity: 0 },                    next: { scale: 1.15, opacity: 0 } },
        'rotate-3d':  { prev: { translate: ['-100%', 0, 0], rotate: [0, 100, 0] }, next: { translate: ['100%', 0, 0], rotate: [0, -100, 0] } },
        'slide-up':   { prev: { translate: [0, '-110%', 0] },                 next: { translate: [0, '110%', 0] } },
      };

      if (
        _this.dataset.swipeMobileOnly === 'true' &&
        _this.globalSlide &&
        typeof _this.globalSlide.destroy === 'function' &&
        !_this.globalSlide.destroyed
      ) {
        _this.globalSlide.destroy(true, true);
        _this.globalSlide = null;
      }

      _this.globalSlide = new Swiper(_this, {
      slidesPerView: effectiveSlidesPerView,
      spaceBetween: effectiveSpaceBetween,
      autoplay: autoplaying,
      direction: effectiveDirection,
      loop: effectiveLoop,
      rewind: isCardsEffect ? cardsRewind : undefined,
      initialSlide: initialSlide,
      centeredSlides: centeredSlides,
      effect: effect,
      fadeEffect:      effect === 'fade'      ? { crossFade: true }                                                              : undefined,
      cubeEffect:      effect === 'cube'      ? { shadow: false, slideShadows: false }                                           : undefined,
      flipEffect:      effect === 'flip'      ? { slideShadows: false }                                                          : undefined,
      coverflowEffect: effect === 'coverflow' ? { rotate: 50, depth: 100, modifier: 1, slideShadows: false }                    : undefined,
      cardsEffect:     effect === 'cards'     ? { perSlideRotate: cardsRotate, perSlideOffset: cardsOffset, slideShadows: false } : undefined,
      creativeEffect:  effect === 'creative'  ? (_creativePresets[creativePreset] || _creativePresets['slide-over'])             : undefined,
      grabCursor: grabCursor,
      keyboard: { enabled: keyboardNav },
      slideToClickedSlide: slideToClickedSlide,
      hashNavigation: { enabled: hashNav, watchState: hashNav, replaceState: hashNavReplace },
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: _this.querySelector('.swiper-button-next'),
        prevEl: _this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector('.parent-pagination') ||
          _this.querySelector('.swiper-pagination'),
        type: paginationType,
      },
      breakpoints: customBreakpoints ? customBreakpoints : {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: isCubeEffect ? 0 : (spacing >= 30 ? 30 : spacing),
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: isCubeEffect ? 0 : spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          if (matchHeightSelectors.length > 0) {
            setTimeout(() => _this.matchHeights(matchHeightSelectors), 100);
          }
          var sec__tiktok = _this.closest('.sec__tiktok-video');
          if (_this.classList.contains('slideshow')) {
            const motionElement = _this.querySelectorAll(
              `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup`
            );
            setTimeout(() => {
              motionElement &&
                motionElement.forEach((item) => {
                  item.refreshAnimation();
                });
            }, 350);
          }
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)'
          );
          slide_visibles?.forEach((slide) => {
            if (slide && typeof slide.initialize === 'function') {
              slide.initialize();
            }
          });
          /* Cards effect: force re-render after browser layout + paint are complete.
             Cards uses virtualTranslate:true and per-slide CSS transforms based on
             slide.progress. On first init the swiper may not yet have committed its
             final dimensions (container width, swiperSlideOffset), causing progress
             values to compute as 0/NaN → all slides stacked on top of each other.
             Double-rAF ensures we wait until after the first paint so offsetWidth is
             stable, then update() recomputes sizes → progress → setTranslate.        */
          if (isCardsEffect) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                if (!e.destroyed) e.update();
              });
            });
          }
          e.autoplay.stop();
          if (_this?.dataset.autoplay === 'true') {
            motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: '0px 0px -50px 0px' }
            );
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            if (!_this._resizeTiktok) {
              _this._resizeTiktok = function () {
                setTimeout(() => { _this.initSecTiktok(sec__tiktok); }, 150);
              };
              window.addEventListener('resize', _this._resizeTiktok);
            }
          }
          if (matchHeightSelectors.length > 0) {
            if (!_this._resizeMatchHeight) {
              _this._resizeMatchHeight = function () {
                setTimeout(() => { _this.matchHeights(matchHeightSelectors); }, 150);
              };
              window.addEventListener('resize', _this._resizeMatchHeight);
            }
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              '.product-item__media--ratio'
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
              const swiperArrows = _this.querySelectorAll('.swiper-arrow');
              if (swiperArrows.length) {
                swiperArrows.forEach((arrow) => {
                  arrow.setAttribute('style', arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector('video.slideshow');
          if (video) {
            const getTierSrc = (v) => {
              const w = window.innerWidth;
              return w < 768
                ? (v.dataset.srcMb || v.dataset.src)
                : w < 1025
                  ? (v.dataset.srcTb || v.dataset.src)
                  : v.dataset.src;
            };
            const applyTierSrc = () => {
              _this.querySelectorAll('video').forEach((v) => {
                const dataSrc = getTierSrc(v);
                if (dataSrc && v.src !== dataSrc) {
                  const wasPlaying = !v.paused;
                  v.src = dataSrc;
                  if (wasPlaying) v.play().catch(() => {});
                }
              });
            };
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              applyTierSrc();
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: '0px 0px 200px 0px',
            }).observe(_this);
            /* P-δ: register tier-resync with the shared global resize coordinator
               instead of attaching a per-section listener. One window listener for
               the whole page; on resize it dispatches to every registered SlideSection.
               Reduces window event listener count from O(N) to O(1). */
            (window.__sectionTierResync = window.__sectionTierResync || (function () {
              const fns = new Set();
              let timer;
              window.addEventListener('resize', () => {
                clearTimeout(timer);
                timer = setTimeout(() => fns.forEach((fn) => fn()), 300);
              }, { passive: true });
              return { add: (fn) => fns.add(fn), remove: (fn) => fns.delete(fn) };
            })()).add(applyTierSrc);
            _this._tierResync = applyTierSrc;
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide motion-element:not([data-image])'
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute('hold')) {
              slide?.setAttribute('hold', true);
            }
          });

          setTimeout(() => {
            if (_this.classList.contains('slideshow')) {
              const motionElement = _this.querySelectorAll(
                `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup, .swiper-slide.swiper-slide-active  motion-element.motion-image`
              );
              motionElement &&
                motionElement.forEach((item) => {
                  item.refreshAnimation();
                });
            }
          }, 50);
        },
        slideChange: function (swiper) {
          // 移除当前活动幻灯片的 data-hidden 属性，并恢复图片 src
          const handleActiveSlide = (slide) => {
            if (slide && slide.hasAttribute('data-hidden')) {
              slide.removeAttribute('data-hidden');
              
              // 将 data-src 和 data-srcset 移回 src 和 srcset
              const images = slide.querySelectorAll('img');
              images.forEach((img) => {
                if (img.dataset.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute('data-src');
                }
                if (img.dataset.srcset) {
                  img.srcset = img.dataset.srcset;
                  img.removeAttribute('data-srcset');
                }
              });
              
              // 处理 picture 元素中的 source 标签
              const sources = slide.querySelectorAll('source[data-srcset]');
              sources.forEach((source) => {
                if (source.dataset.srcset) {
                  source.srcset = source.dataset.srcset;
                  source.removeAttribute('data-srcset');
                }
              });
            }
          };
          
          // 使用 Swiper API 获取当前活动的幻灯片
          const activeIndex = swiper.activeIndex;
          if (swiper.slides && swiper.slides[activeIndex]) {
            handleActiveSlide(swiper.slides[activeIndex]);
          } else {
            // 后备方案：使用 querySelector
            const activeSlide = _this.querySelector('.swiper-slide-active');
            if (activeSlide) {
              handleActiveSlide(activeSlide);
            }
          }
          
          const index_currentSlide = swiper.realIndex + 1;
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove('active');
            });
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add('active');
          }
        }
      },
    });
    };

    // Use requestIdleCallback to avoid blocking main thread, with setTimeout fallback
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(initSlideInternal, { timeout: 100 });
    } else {
      // Fallback: use setTimeout to defer execution
      setTimeout(initSlideInternal, 0);
    }
  }

  matchHeights(selectors) {
    if (!selectors || selectors.length === 0) return;
    
    selectors.forEach(selector => {
      const elements = this.querySelectorAll(selector);
      if (elements.length === 0) return;

      // Reset heights
      elements.forEach(el => el.style.height = 'auto');

      // Calculate max height
      let maxHeight = 0;
      elements.forEach(el => {
        if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
      });

      // Apply max height
      elements.forEach(el => el.style.height = `${maxHeight}px`);
    });
  }

  initSecTiktok(sec) {
    sec.querySelectorAll('.swiper-slide').forEach((arrow) => {
      const tiktok = arrow.querySelector('.section_tiktok-image');
      if (!tiktok) return;
      let width = '--item-width: ' + arrow.offsetWidth;
      tiktok.setAttribute('style', width);
    });
  }

  disconnectedCallback() {
    if (this._mobileOnlyMq && this._mobileOnlySync) {
      this._mobileOnlyMq.removeEventListener('change', this._mobileOnlySync);
      this._mobileOnlyMq = null;
      this._mobileOnlySync = null;
    }
    this._destroySwiperInstance();
    if (this._resizeTiktok) {
      window.removeEventListener('resize', this._resizeTiktok);
      this._resizeTiktok = null;
    }
    if (this._resizeMatchHeight) {
      window.removeEventListener('resize', this._resizeMatchHeight);
      this._resizeMatchHeight = null;
    }
    /* P-δ: unregister from the shared video tier resync coordinator so its
       Set never holds a reference to a removed section (Theme Editor reorder/
       delete, page navigation in SPA-like contexts). */
    if (this._tierResync && window.__sectionTierResync) {
      window.__sectionTierResync.remove(this._tierResync);
      this._tierResync = null;
    }
  }
}
customElements.define('slide-section', SlideSection);
function armNextBannerTimers(scope) {
  var root = scope && scope.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-next-banner-start]').forEach(function (section) {
    if (section._nextBannerArmed) return;
    section._nextBannerArmed = true;
    var targetMs = new Date(section.dataset.nextBannerStart).getTime();
    var triggered = false;

    function refresh() {
      if (triggered) return;
      triggered = true;
      var el = document.getElementById(section.id);
      fetch(window.location.href, { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(section.id);
          if (fresh && el && el.isConnected) {
            el.replaceWith(fresh);
            var dispatchTarget = (fresh.closest && fresh.closest('.shopify-section')) || fresh.parentNode || fresh;
            dispatchTarget.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
            armNextBannerTimers(fresh);
          } else {
            window.location.reload();
          }
        })
        .catch(function () { window.location.reload(); });
    }

    var delay = targetMs - Date.now();
    if (delay > 0 && delay < 86400000) setTimeout(refresh, delay);
    document.addEventListener('visibilitychange', function onVisible() {
      if (!document.hidden && Date.now() >= targetMs) {
        document.removeEventListener('visibilitychange', onVisible);
        refresh();
      }
    });
  });
}
document.addEventListener('DOMContentLoaded', function () { armNextBannerTimers(); });
document.addEventListener('shopify:section:load', function (e) {
  armNextBannerTimers(e.target);
});

/**
 * Focus trap utility — keeps keyboard focus within a container (WCAG 2.1 SC 2.1.2)
 * Returns a cleanup function that removes the event listener.
 */
function trapFocus(container) {
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const focusable = Array.from(container.querySelectorAll(FOCUSABLE));
  if (!focusable.length) return function () {};

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  first.focus();

  function onKeyDown(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  container.addEventListener('keydown', onKeyDown);
  return function () { container.removeEventListener('keydown', onKeyDown); };
}

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
    this._focusTrapCleanup = null;
  }

  initPopup(content, text, customClass, afterOpen) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        document.documentElement.classList.add('open-popup');
        root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
        _this._focusTrapCleanup = trapFocus(this.modalBox);

        if(afterOpen) afterOpen(this.modalBox);

        const video = this.modalBox.querySelector('video');
        if (!video) return;
        video.load();
        let userPaused = false;
        const safePlay = () => {
          if (!userPaused && video.paused && video.readyState >= 3) {
            video.play().catch(err => console.log("Auto-resume blocked:", err));
          }
        };
        const onPlay  = () => { userPaused = false; };
        const onPause = () => { if (video.readyState >= 3 && !video.ended) userPaused = true; };
        video.addEventListener('play', onPlay);
        video.addEventListener('pause', onPause);
        video.addEventListener('canplay', () => {
          video.play().catch(err => console.log("Initial autoplay blocked:", err));
        }, { once: true });
        video.addEventListener('canplaythrough', safePlay);
        this.playInterval = setInterval(() => safePlay(), 3000);
        this._videoCleanup = () => {
          video.removeEventListener('play', onPlay);
          video.removeEventListener('pause', onPause);
          video.removeEventListener('canplaythrough', safePlay);
        };

        if (this.modal.classList.contains('shopable-video')) {
          video.muted = false;
        }
      },
      onClose: function () {
        clearInterval(this.playInterval);
        if (_this._videoCleanup) { _this._videoCleanup(); _this._videoCleanup = null; }
        if (_this._focusTrapCleanup) { _this._focusTrapCleanup(); _this._focusTrapCleanup = null; }
        document.documentElement.classList.remove('open-popup');
        root.style.removeProperty('padding-right');
      },
      beforeClose: function () {
        clearInterval(this.playInterval);
        if (_this._videoCleanup) { _this._videoCleanup(); _this._videoCleanup = null; }
        if (_this._focusTrapCleanup) { _this._focusTrapCleanup(); _this._focusTrapCleanup = null; }
        _this.onCloseEvent();
        document.documentElement.classList.remove('open-popup');
        root.style.removeProperty('padding-right');
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement('div');
      popup_header.classList.add('tingle-modal-box__header');
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {
  }
}


// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    // window.pauseAllMedia(); // Tinsley Modified
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (!deferredElement) return;
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const elementErrorMessage = html.querySelector(
        '.product-form__error-message-wrapper'
      );
      if (!elementErrorMessage) return;
      const elementMessage = elementErrorMessage.querySelector(
        '.product-form__error-message'
      );
      if (!elementMessage) return;
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = '') {
  let toastContainer = document.getElementById('toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  toast.classList.remove('show');
  setTimeout(() => {
    toast.remove();
    if (!document.querySelector('#toast-container .toast')) {
      document.getElementById('toast-container').remove();
    }
  }, 500);
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      'loading' === document.readyState
        ? document.addEventListener(
            'DOMContentLoaded',
            this._loadEverythingReadyNow.bind(this)
          )
        : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add('swiper-lazy');
    document.body.classList.add('review-lazy');
    const loadingSwiper = document.querySelectorAll(
      '.lazy-loading-swiper-after'
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove('lazy-loading-swiper-after');
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll('.review-product-added');
    reviewProduct.forEach((el) => {
      el.classList.remove('review-product-added');
      el.innerHTML = el.querySelector('.product-review-json').innerHTML;
      el.classList.remove('inline-loading');
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === 'true';
    const loop = _this?.dataset.loop === 'true';
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : '';
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : 'horizontal';
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide';
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === 'true';
    const autoItem = _this?.dataset.itemMobile === 'true';
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    const autoplayPauseOnMouseEnter = _this?.dataset.autoplayPauseOnMouseEnter === 'true';
    if (autoplayPauseOnMouseEnter) {
      if (autoplaying) {
        autoplaying.pauseOnMouseEnter = true;
      } else {
        autoplaying = { delay: autoplaySpeed, pauseOnMouseEnter: true };
      }
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == 'vertical') {
      _this.style.maxHeight = _this.offsetHeight + 'px';
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? 'auto' : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: _this.querySelector('.swiper-button-next'),
        prevEl: _this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector('.parent-pagination') ||
          _this.querySelector('.swiper-pagination'),
        type: progressbar ? 'progressbar' : 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? 'progressbar' : 'bullets',
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? 'progressbar' : 'bullets',
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)'
          );
          slide_visibles?.forEach((slide) => {
            slide?.initialize();
          });
          e.autoplay.stop();
          if (_this?.dataset.autoplay === 'true') {
            motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: '0px 0px -50px 0px' }
            );
          }
          var sec__tiktok = _this.closest('.sec__tiktok-video');
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener('resize', function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              '.product-item__media--ratio'
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
              const swiperArrows = _this.querySelectorAll('.swiper-arrow');
              if (swiperArrows.length) {
                swiperArrows.forEach((arrow) => {
                  arrow.setAttribute('style', arrowsOffset);
                });
              }
            }
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide motion-element:not([data-image])'
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute('hold')) {
              slide?.setAttribute('hold', true);
            }
          });
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove('active');
            });
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add('active');
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event('glozinspeed-allScriptsLoaded'));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement('script');
        let n;
        [...e.attributes].forEach((e) => {
          let t = e.nodeName;
          'type' !== t &&
            ('data-glozinlazy-type' === t && ((t = 'type'), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute('src')
            ? (s.addEventListener('load', t), s.addEventListener('error', t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e);
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event('glozinspeed-DOMContentLoaded')),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-DOMContentLoaded')),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event('glozinspeed-readystatechange')),
      await this._requestAnimFrame(),
      document.glozinonreadystatechange && document.glozinonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-load')),
      await this._requestAnimFrame(),
      window.glozinonload && window.glozinonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-pageshow')),
      await this._requestAnimFrame(),
      window.glozinonpageshow && window.glozinonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      'keydown',
      'mousemove',
      'touchmove',
      'touchstart',
      'touchend',
      'wheel',
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener('click', this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add('copied');
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define('copy-button', CopyButton);

if (!customElements.get('marquee-drag')) {
  customElements.define('marquee-drag', class extends HTMLElement {

    // ── lifecycle ─────────────────────────────────────────────────────────

    connectedCallback() {
      this._box = this.querySelector('.marquee-box');
      if (!this._box) return;

      const parsedSpeed = parseFloat(this.dataset.speed);
      this._speed = Number.isFinite(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : 20;
      this._direction = this.dataset.direction || 'left'; // 'left' | 'right'

      // Time-based animation tracking (avoids GPU-compositor / getComputedStyle mismatch)
      this._animStartTime = 0; // performance.now() when animation progress = 0
      this._activationPending = false;
      this._rafIds = new Set();

      this._setupViewportObserver();

      // NOTE: We intentionally do NOT gate drag/animation on
      // `prefers-reduced-motion` — this marquee's purpose is to cycle
      // through content that can't all fit on screen; disabling it would
      // hide content from users who need this preference.

      this._isDragging    = false;
      this._hasDragged    = false;
      this._startX        = 0;
      this._baseX         = 0;
      this._latestDragX   = 0;
      this._rafPending    = false;
      this._velocityX     = 0;   // px/ms, tracked for inertia
      this._prevEventX    = 0;
      this._prevEventTime = 0;

      this._onDown   = this._onDown.bind(this);
      this._onMove   = this._onMove.bind(this);
      this._onUp     = this._onUp.bind(this);
      this._onCancel = this._onCancel.bind(this);

      // Drag area is limited to marquee content only (exclude section header).
      this._box.addEventListener('pointerdown',   this._onDown);
      this._box.addEventListener('pointermove',   this._onMove);
      this._box.addEventListener('pointerup',     this._onUp);
      this._box.addEventListener('pointercancel', this._onCancel);
    }

    disconnectedCallback() {
      this._observer?.disconnect();
      this._activationPending = false;
      for (const rafId of this._rafIds || []) cancelAnimationFrame(rafId);
      this._rafIds?.clear();
      this._rafPending = false;
      if (this._box) this._box.style.willChange = '';
      if (this._onDown && this._box) {
        this._box.removeEventListener('pointerdown',   this._onDown);
        this._box.removeEventListener('pointermove',   this._onMove);
        this._box.removeEventListener('pointerup',     this._onUp);
        this._box.removeEventListener('pointercancel', this._onCancel);
      }
    }

    _requestFrame(callback) {
      const rafId = requestAnimationFrame(() => {
        this._rafIds?.delete(rafId);
        callback();
      });
      this._rafIds?.add(rafId);
      return rafId;
    }

    // ── viewport observer ─────────────────────────────────────────────────

    _setupViewportObserver() {
      // Fire on ANY intersection (threshold 0) — 20% was too strict for tall
      // sections with heading + padding; element could remain sub-threshold
      // through most of the page, so animation never started.
      this._observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        this._activateViewport();
      }, { rootMargin: '50px', threshold: 0 });
      this._observer.observe(this);

      // Shopify Theme Editor can replace a visible section without producing a
      // reliable observer transition. Re-check after layout so visible
      // instances still reveal their content and start animation.
      this._requestFrame(() => {
        if (!this.isConnected || this.classList.contains('in-viewport')) return;
        const rect = this.getBoundingClientRect();
        const viewportHeight = document.documentElement?.clientHeight || window.innerHeight;
        if (rect.width > 0 && rect.height > 0 && rect.bottom > -50 && rect.top < viewportHeight + 50) {
          this._activateViewport();
        }
      });
    }

    _activateViewport() {
      if (!this._box || this.classList.contains('in-viewport') || this._activationPending) return;
      this._activationPending = true;
      this._observer?.disconnect();

      // Double rAF lets content-visibility: hidden → visible transition fully
      // settle its layout before we measure offsetWidth.
      this._requestFrame(() => {
        if (!this.isConnected || !this._box) {
          this._activationPending = false;
          return;
        }
        this.classList.add('in-viewport'); // triggers image loading via CSS
        this._requestFrame(() => {
          if (!this.isConnected || !this._box) {
            this._activationPending = false;
            return;
          }
          void this._box.offsetHeight; // force reflow so measurements are post-layout
          this._box.style.willChange = 'transform'; // promote GPU layer only when animating
          this._startAnimation(0, this._direction);
          this._activationPending = false;
        });
      });
    }

    // ── animation control ─────────────────────────────────────────────────

    /**
     * Start (or resume) the CSS animation at a given pixel offset.
     * Uses negative animation-delay to fast-forward to the right keyframe.
     * Records _animStartTime so _getCurrentPosition() can track progress
     * without relying on getComputedStyle (which returns wrong values for
     * GPU-composited animations).
     */
    _startAnimation(posX, direction) {
      this._direction = direction;
      const totalWidth = this._box.offsetWidth / 2;

      // Compute progress defensively: when totalWidth is 0 (layout not yet
      // ready / fresh connect), still kick off the animation at progress 0.
      // The animation will self-correct on the next cycle once layout settles.
      // Previously we bailed out when width was 0, which left the marquee
      // permanently frozen if the retry budget ran out before layout was ready.
      let progress = 0;
      if (totalWidth > 0) {
        let norm = posX % totalWidth;
        if (norm > 0) norm -= totalWidth;
        progress = direction === 'right'
          ? (totalWidth + norm) / totalWidth  // right: -totalWidth→0, progress 0→1
          : Math.abs(norm) / totalWidth;      // left:  0→-totalWidth, progress 0→1
      }

      const animName = direction === 'right' ? 'move-to-right' : 'move-to-left';
      const delay    = -(progress * this._speed); // negative = start mid-cycle

      // Record the conceptual t=0 of this animation cycle for time-based tracking
      this._animStartTime = performance.now() + delay * 1000;

      this._box.style.transform = '';
      this._box.style.animation = `${animName} ${this._speed}s ${delay}s linear infinite`;
    }

    /**
     * Calculate where the box currently is, using elapsed time rather than
     * getComputedStyle — avoids the GPU-compositor desync that causes drag
     * start-position jumps.
     */
    _getCurrentPosition() {
      const totalWidth = this._box.offsetWidth / 2;
      if (totalWidth <= 0) return 0;
      const elapsed  = performance.now() - this._animStartTime;
      const progress = (elapsed % (this._speed * 1000)) / (this._speed * 1000);
      return this._direction === 'right'
        ? -totalWidth + progress * totalWidth  // -totalWidth → 0
        : -progress * totalWidth;              // 0 → -totalWidth
    }

    _pause() {
      this._baseX = this._getCurrentPosition();
      this._box.style.animation = 'none';
      this._box.style.transform = `translateX(${this._baseX}px)`;
    }

    // ── pointer events ────────────────────────────────────────────────────

    _onDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      const interactive = e.target?.closest('a, button, [role="button"], input, textarea, select, label');
      if (interactive) return;
      e.preventDefault();
      this._hasDragged    = false;
      this._isDragging    = true;
      this._startX        = e.clientX;
      this._latestDragX   = e.clientX;
      this._prevEventX    = e.clientX;
      this._prevEventTime = performance.now();
      this._velocityX     = 0;
      this._pause();
      this._box.setPointerCapture(e.pointerId);
      this.classList.add('is-dragging');
      this._box.style.userSelect = 'none';
    }

    _onMove(e) {
      if (!this._isDragging) return;
      e.preventDefault();

      // Track velocity with a short window (ignore gaps > 100 ms — e.g. tab switch)
      const now = performance.now();
      const dt  = now - this._prevEventTime;
      if (dt > 0 && dt < 100) {
        this._velocityX = (e.clientX - this._prevEventX) / dt; // px/ms
      }
      this._prevEventX    = e.clientX;
      this._prevEventTime = now;
      this._latestDragX   = e.clientX;
      if (Math.abs(this._latestDragX - this._startX) > 5) this._hasDragged = true;

      // rAF throttle — one style write per frame, not per event (can be 120 Hz)
      if (!this._rafPending) {
        this._rafPending = true;
        this._requestFrame(() => {
          this._rafPending = false;
          if (!this._isDragging) return;
          this._box.style.transform =
            `translateX(${this._baseX + (this._latestDragX - this._startX)}px)`;
        });
      }
    }

    _onUp(e) {
      if (!this._isDragging) return;
      this._isDragging = false;

      const dx    = e.clientX - this._startX;
      // Inertia: project velocity forward 200 ms for a natural coast feel
      const coast = this._velocityX * 200;
      const finalX = this._baseX + dx + coast;

      // Change direction when drag + coast is intentional (> 40 px or fast flick)
      const displacement = dx + coast;
      const newDir = (Math.abs(dx) > 40 || Math.abs(this._velocityX) > 0.3)
        ? (displacement < 0 ? 'left' : 'right')
        : this._direction;

      this._startAnimation(finalX, newDir);
      this._endDrag();

      // Tap (no real drag): manually fire click so links remain usable
      if (!this._hasDragged) {
        const target = document.elementFromPoint(e.clientX, e.clientY);
        const interactive = target?.closest('a, button, [role="button"]');
        if (interactive) interactive.click();
      }
    }

    _onCancel() {
      if (!this._isDragging) return;
      this._isDragging = false;
      this._startAnimation(this._baseX, this._direction); // restore without direction change
      this._endDrag();
    }

    _endDrag() {
      this.classList.remove('is-dragging');
      this._box.style.userSelect = '';
    }
  });
}
